<template>
  <div class="stoplist-category-wrapper" v-if="filteredProducts.length">
      <div 
        class="stoplist-category-header"
        :class="{
            'collapsed': is_collapsed
        }" @click="is_collapsed = !is_collapsed">
          <div class="stoplist-category-name qrw-container-title-sm">
              {{ category.name }}
          
          </div>
            <span class="count"> | {{ filteredProducts.length }} </span>
          <div class="stoplist-category-action">
              <BaseIcon :icon="is_collapsed ? 'plus' : 'minus'" size="sm2"/>
          </div>
      </div>
      <div class="stoplist-category-items" v-if="!is_collapsed">
          <StoplistCategoryItem
            :product="product"
            :menu="menu"
            :stoplist="stoplist"
            @toggle="(id, v) => $emit('toggle', id, v)"
            v-for="product in filteredProducts"
            :key="product._id+product.name"/>
      </div>
  </div>
</template>

<script>
import StoplistCategoryItem from "@/components/stoplist/StoplistCategoryItem.vue"

export default {
    data() {
        return {
            is_collapsed: false
        }
    },
    props: {
        category: Object,
        menu: Object,
        stoplist: Array,
        search: String
    },
    components: {
        StoplistCategoryItem
    },
    computed: {
        categoryProducts() {
            return this.menu.products.filter(product => product.category_id === this.category._id);
        },
        filteredProducts() {
            if (!this.search) return this.categoryProducts;

            const q = this.search.toLowerCase();

            return this.categoryProducts.filter(p => {
                return p.name.toLowerCase().includes(q);
            });
        }
    }
}
</script>

<style scoped>
.stoplist-category-wrapper {
    width: 100%;
}

.stoplist-category-name {
    display: -webkit-box;
    -webkit-box-orient:vertical;
    overflow: hidden;
    width: 85%;
    text-overflow: ellipsis;
    line-clamp: 2;
    -webkit-line-clamp: 2;
}

.stoplist-category-header {
    padding: 16px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    background: var(--black-1-color);
    color: var(--white-10-color);
}

.stoplist-category-header .count {
    color: var(--grey-1-color);
    display: flex;
    width: fit-content;
    margin-left: auto;
    padding-right: 8px;
}

.stoplist-category-header.collapsed .count {
    color: var(--grey-1-color);
}

.stoplist-category-header.collapsed {
    background: var(--white-9-color);
    color: var(--black-4-color);
}

.stoplist-category-action {
    height: 16px;
    display: flex;
    align-content: center;
    align-items: center;
    align-self: center;
}
</style>